// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"f99da383","218":"d41a3243","412":"0d6b1b9c","453":"1c6375f5","650":"9c9dbede"}[chunkId] + ".chunk.js";
};